// A wide strip (the milestone track, a rail, the stages), a table or a board scrolls sideways inside its box. When it
// is wider than its box, the box becomes a focusable, named region so the keyboard can scroll it (WCAG 2.1.1, axe
// scrollable-region-focusable). One measure for all of them; under SSR nothing is measured: no region.

import { useRef, useState } from "react";
import { useIsoLayoutEffect } from "./useIsoLayoutEffect";

export function useOverflow<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  const [overflows, setOverflows] = useState(false);
  useIsoLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const measure = () => setOverflows(element.scrollWidth > element.clientWidth + 1);
    measure();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    const inner = element.firstElementChild;
    if (inner) observer.observe(inner);
    return () => observer.disconnect();
  }, []);
  return { ref, overflows };
}

/** The wrapper's props: a region named by `label` while it overflows. */
export function regionProps(overflows: boolean, label: string | undefined) {
  return overflows ? ({ role: "region", tabIndex: 0, "aria-label": label } as const) : {};
}
